import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../../redux/posts/action";
import SubmitProjectProposalForm from "./SubmitProjectProposalForm";
import getTimeDifference from "../../../../Common/TimeDifference";
import { formatNumberWithCommas, getPosttype } from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import DeadlineComponents from "../../../../Common/DeadlineComponents";
import HomeCommonNavigation from "../../../../Common/HomeCommonNavigation";

export default function SubmitProjectProposal() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const path = "Assets/scss/FindWork.module.scss";
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  useEffect(() => {
    if (Array.isArray(posts?.my_proposal) && posts?.my_proposal?.length > 0) {
      navigate(`/${lan}/projectdetails/${posts.id}`);
    }
  }, [posts, posts?.my_proposal, posts?.my_proposal?.length]);

  return (
    <div className=" project-section submit-proposal  col-lg-10 mx-auto">
      <p className="breadcrumbs">
        {/* <a onClick={() => navigate(`/${lan}/searchall`)}>Home &gt; </a> */}
        <HomeCommonNavigation type={posts?.type} />
        <a onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}>
          Project details &gt;
        </a>
        Send offer
      </p>
      <div className="col-lg-10 mx-auto mob-pad">
        <div className="proposal-section">
          <h5>Submit your proposal</h5>
          <div className="filter-detail justift-content-between">
            <div className="w-100">
              <h5>
                {posts.title} <span className="project">{getPosttype(posts.type)}</span>
              </h5>
              <div className="dollar-sec">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                    alt=""
                  />
                  {posts?.type == 2 ? "Prize" : "Budget"}: $
                  {formatNumberWithCommas(posts.price)}
                </p>
                {posts?.type == 3 ? (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                      alt=""
                    />
                    Job type:
                    {posts?.work_location == 1
                      ? "Virtual"
                      : posts?.work_location == 2
                        ? "Physical"
                        : ""}
                  </p>
                ) : (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                      alt=""
                    />
                    <DeadlineComponents posts={posts} />
                  </p>
                )}
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                    alt=""
                  />
                  Posted:
                  {getTimeDifference(posts.created_on)}
                </p>
              </div>
              <CustomeCategoryandSubcategory posts={posts} />
              <CustomReactQuillDescription value={posts.description} />
              <div className="photoshop">
                {Array.isArray(posts?.skills) &&
                  posts?.skills.map((item1, index1) => (
                    <p key={index1}>{item1.title}</p>
                  ))}
              </div>
              <div className="proposal">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                    alt=""
                  />
                  {posts?.type == 2 ? "Entries" : "Proposal"}:
                  {posts.proposal_count}
                </p>
                {posts?.type == 3 ? (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                      alt=""
                    />
                    Location: {posts.city_name}
                  </p>
                ) : (
                  ""
                )}
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                    alt=""
                  />
                  Verified Payment
                </p>
              </div>
            </div>
            <button
              onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}
              className="btn view-post"
            >
              View post
            </button>
          </div>
          <SubmitProjectProposalForm />
        </div>
      </div>
    </div>
  );
}
